"use client"

import type { FC, ReactNode } from "react"
import { useDevMode } from "app/contexts/DevModeContext"

interface DevOnlyProps {
  children: ReactNode
  /** falseにすると開発環境でもisDevUIVisibleに関係なく表示しない */
  enabled?: boolean
}

/**
 * 開発モードの時のみ子要素を表示するラッパーコンポーネント
 * - NODE_ENV === "development" かつ isDevUIVisible === true の場合のみ表示
 * - 本番環境では何も表示しない
 *
 * @example
 * <DevOnly>
 *   <Button>開発専用ボタン</Button>
 * </DevOnly>
 */
export const DevOnly: FC<DevOnlyProps> = ({ children, enabled = true }) => {
  const { isDevMode } = useDevMode()

  if (!enabled || !isDevMode) {
    return null
  }

  return <>{children}</>
}
